/** ===============================
 * 打点相关枚举/常量
 ================================= */

 /**
  * 分享曝光错误枚举
  */
 exports.DCShareShowError = {
    None: "0",    // 无错误，可以正常分享
    Limit: "1",   // 分享次数达上限
    NoTicket: "2",   // 无门票-友谊赛
 }
